type Props = {
  title: string;
  body: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmModal({
  title,
  body,
  confirmLabel = "Delete",
  onConfirm,
  onCancel,
}: Props) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(10,10,8,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
      }}
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 420,
          background: "var(--sa-bg-pure)",
          border: "1px solid var(--sa-border)",
          padding: "32px 32px 28px",
          borderRadius: 2,
        }}
      >
        <div className="sa-label" style={{ marginBottom: 12 }}>
          Confirm
        </div>
        <h3
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 500,
            fontSize: 22,
            margin: "0 0 12px",
            letterSpacing: "-0.01em",
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontFamily: "var(--sa-serif)",
            fontSize: 15,
            lineHeight: 1.6,
            color: "var(--sa-muted-fg)",
            margin: "0 0 24px",
          }}
        >
          {body}
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button className="sa-btn sa-btn--ghost" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="sa-btn"
            onClick={onConfirm}
            style={{
              background: "var(--sa-danger)",
              borderColor: "var(--sa-danger)",
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
